import {GameListType} from "./GameList";

export function isMobile(userAgent: string, screenWidth: number = 1, screenHeight: number = 1): boolean {
    // ensure that "height" is longer dimension for calculations
    if (screenWidth > screenHeight) {
        const temp = screenHeight;
        screenHeight = screenWidth;
        screenWidth = temp;
    }
    if (!userAgent) {
        return false;
    }

    userAgent = userAgent.toLowerCase()
    if (/(ipad|tablet)/.test(userAgent)) {
        return false; // tablet!
    }

    if (/webos|iphone|ipod|blackberry|bb|playbook|iemobile|windows phone|kindle|silk|opera mini/.test(userAgent)) {
        return true; // mobile!
    }

    const ratio = screenHeight / screenWidth;
    if (/android/.test(userAgent)) {
        const isTablet = (screenHeight > 1100 && ratio > 0.67) || (screenHeight > 1200 && ratio > 0.62);
        return !isTablet
    }

    if (/mobi/.test(userAgent)) {
        return true; // other mobiles
    }

    return false; //desktop
}

export function safeCreateUrl(address): URL {
    let retUrl: URL;
    try {
        retUrl = new URL(address);
    } catch (e) {
        console.error(e);
        throw new Error("Wrong url format: " + address);
    }
    return retUrl;
}

export function findGame(gameId: string, gameList: GameListType) {
    return gameList.find(game => game.id === gameId);
}